export default {
  select_size: 'Select a size',
  required: 'Required',
  required_missing: 'Required — please make a selection',
  optional: 'Optional',
  select_up_to: 'Select up to {{maxCount}}',
};
